import React from 'react';
import AppApi from "../../api/app";
import toast from 'react-hot-toast';
import gallery from "../../api/gallery";
import * as Yup from "yup";
import { ErrorMessage, Field, Form, Formik } from "formik";
let validationSchema = Yup.object({
   locationTitle: Yup.string().required("Locations title  is required."),
   deliveryCost: Yup.number().typeError("Please enter valid cost in numbers").min(0, "Numbers can not less then 0.").required("Please enter valid cost in numbers"),
});

function addLocation({ updateList, data }) {


   return (
      <>
         <Formik
            initialValues={{
               locationTitle: data?.locationTitle || "",
               deliveryCost: data?.deliveryCost || 0,
            }}
            validationSchema={validationSchema}
            onSubmit={async (values, { setSubmitting, resetForm }) => {
               setSubmitting(true);
               try {
                  let res = ""
                  if (data?._id) {
                     let apiData = {
                        locationId: data?._id,
                        locationTitle: values.locationTitle,
                        deliveryCost: values.deliveryCost,
                     }
                     res = await AppApi.updateLocation(apiData);
                  } else {
                     res = await AppApi.addLocation(values);
                  }
                  if (res?.data?.error == false) {
                     toast.success(res?.data?.msg);
                  }
                  resetForm();
                  updateList(res?.data?.data);
                  setSubmitting(false);
               } catch (error) {
                  console.log(error.message);
                  setSubmitting(false);
               }
            }}
         >
            {({ isSubmitting, values, errors, setFieldValue }) => (
               <Form>
                  <div className=" form mt-1">
                     <div className="form-group flex-grow-1">
                        <label>Locations Title</label>
                        <Field
                           name="locationTitle"
                           type="text"
                           className="form-control rounded"
                           placeholder="location title"
                        />
                        <ErrorMessage component="small" className='text-danger' name="locationTitle" />
                     </div>
                  </div>
                  <div className="form-group mt-1">
                     <label>Delivery Cost</label>
                     <Field
                        name="deliveryCost"
                        type="number"
                        className="form-control rounded"
                        placeholder="location cost"
                     />
                     <ErrorMessage component="small" className='text-danger' name="deliveryCost" />
                  </div>
                  <div className="p-0 mt-5 text-left col-sm-12">
                     <div className="mb-1 form-group">
                        <button type="submit" disabled={isSubmitting} className="w-100 btn rounded-0 btn-dark">{isSubmitting ? "Loading..." : data?._id ? "Update" : "Add"}</button>
                     </div>
                  </div>
               </Form>
            )}
         </Formik>
         <br />
         <br />
         <br />
         {data?._id && (
            <div className="d-flex justify-content-end">
               <button className='btn btn-danger rounded-0'
                  onClick={async () => {
                     let apiData = {
                        categoryId: data?._id,
                        deleted: true
                     }
                     let res = await AppApi.updateCategory(apiData);
                     if (res?.data?.error == false) {
                        toast.success("Locations deleted successfully.");
                        updateList(data, true);
                     }

                  }}
               ><i className='fas fa-trash'></i> Delete  </button>
            </div>
         )}
      </>
   )
}

export default addLocation